// 企业签约

import fetch,{ postFrom } from '../utils/fetch';

// 判断房间是否可出租
export function roomCanRent(params) {
  // return fetch({
  //     method: 'GET',
  //     url: 'enterprisecontract/roomCanRent',
  //     params
  // })
  return postFrom('enterprisecontract/roomCanRent',params)
}

//根据手机号查询用户资质信息 /enterprisecontract/findCustomerQualification
export function findCustomerQualification(phone,projectFid) {
  return fetch({
      method: 'GET',
      url: 'enterprisecontract/findCustomerQualification',
      params : {
        phone,
        projectFid
      }
  })
}

// 企业计算价格
export function calculatePrice(data) {
  return fetch({
      method: 'POST',
      url: 'enterprisecontract/epsContract/calculatePrice',
      data
  })
}

// 创建企业合同
export function createContract(data) {
  return fetch({
      method: 'POST',
      url: 'enterprisecontract/epsContract/create',
      data
  })
}

//根据租期方式和租期时间查询付款方式
export function choosePayment(data) {
  return fetch({
      method: 'POST',
      url: 'enterprisecontract/choosePayment',
      data
  })
}
//获取企业资质下拉框
export function getQualificationChooses(params) {
  return fetch({
    method: 'GET',
    url: 'enterprisecontract/getQualificationChooses',
    params
  })
}
